<template>
   <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-badge display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            LISTADOS DE PUESTOS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            PUESTOS NUEVOS
          </p>
        </div>
      </div>
    </div>
          
       

    <div class="border border-1 mx-2 mt-2">

      <div class="col-12 d-flex justify-content-end mt-2">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
            <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
            aria-label=".form-control-lg example" placeholder="NOMBRE" v-model="filterField" @input="filtro" />
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">ID</th>
              <th scope="col">NOMBRE DEL PUESTO</th>
              <th scope="col">SECTOR</th>
              <th scope="col">CLASIFICACIÓN</th>
              <th scope="col">ESTADO</th>
              <th scope="col">NOMBRE DE ESTADO</th>
              <th scope="col">DESCRIPCION</th>
              <th scope="col">ACCIÓN</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="loading">
              <td colspan="11" class="text-center align-middle" style="height: 250px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" role="status" style="width: 4rem; height: 4rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>
            <tr v-else v-for="(post, index) in paginatedPosts" :key="post.idPuesto || index"
              class="text-center align-middle reducirTamaño">

              <td scope="row" class="text-center tabla-estiloCompreso fw-semibold text-primary">

                <i class="bi bi-person-badge-fill me-1"></i>{{ post.idPuesto }}
              </td>

              <td class="text-dark">
                <i class="bi bi-person-fill me-1 text-info"></i>{{ post.ptoNombre }}
              </td>

              <td class="text-dark">
                <i class="bi bi-building-fill me-1 text-brown" style="color: #8B4513;"></i>{{ post.ptoSector }}
              </td>

              <td class="text-dark ">
                <i class="bi bi-diagram-3-fill me-1 text-warning"></i>{{ post.ptoClasificacion }}
              </td>

              <!-- Estado -->
               <td v-if="post.ptoEstado == 0" class="fw-bold text-success text-center">
                                <i class="bi bi-check-circle-fill me-1"></i> VIGENTE
                            </td>
                             <td v-if="post.ptoEstado == 1" class="fw-bold text-danger text-center">
                                <i class="bi bi-check-circle-fill me-1"></i> NO VIGENTE
                            </td>
                            <td v-if="post.ptoEstado == 3" class="fw-bold text-warning text-center">
                                <i class="bi bi-x-circle-fill me-1"></i> EN PROCESO DE APROBACION
                            </td>
                              <td>
                                <span v-if="post.aprEstado === '002'" class="text-success">
                                    <i class="bi bi-check-circle-fill me-1"></i>
                                    APROBADO
                                </span>

                                <span v-else-if="post.aprEstado === '003'" class="text-danger">
                                    <i class="bi bi-x-circle-fill me-1"></i>
                                    RECHAZADO
                                </span>

                                <span v-else-if="post.aprEstado === '001'" class="text-warning">
                                    <i class="bi bi-hourglass-split me-1"></i>
                                    SOLICITUD DE APROBACIÓN
                                </span>
                            </td>
                            <td>
                                {{ post.aprDescripcion }}
                            </td>

              <td class="text-center d-flex align-items-center justify-content-center py-1">
                         
                <div class="ms-2">
                  <a v-if="post.docAdjunto != ''" :href="url + post.docAdjunto.slice(49)" target="_blank">
                    <button class="btn btn-primary text-white boton-estiloCuadrado">
                      <i class="bi bi-file-earmark-pdf-fill"></i>
                    </button>

                  </a>
                  <button v-else class="btn btn-secondary text-white boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </button>

                </div>

              </td>
            </tr>
            <tr v-if="!loading && paginatedPosts.length === 0">
              <td colspan="11" class="text-center text-secondary py-4">
                <i class="bi bi-exclamation-triangle text-warning me-1"></i>
                No se encontraron resultados
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <span class="pagination-info small fw-semibold text-secondary">
        Página {{ currentPage }} de {{ totalPages }}
      </span>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "SolimanologPuestosRegistrar",


  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Puestos",

      from:{
        DesCrea:""
      },
      filterField: "",
      cerrarTable1: true,
      cerrarTable2: false,
      currentPage: 1,      // ✅ Página actual
      itemsPerPage: 15,
      noAvanzar: false,
      noRetroceder: false,
      loading: false,
      fileInputKey: 0,
      IdPuesto: "",

      nombrePersona: "",
      nombrePuesto: "",
      sector: "",
      clasificacion: "",
      categoria: "",
      fechaCreacion: "",
      destinatarios: [], // "correo1@x.com,correo2@x.com"
      proyectos: [],
   
    };
  },

  created() {
    this.from.DesCrea = localStorage.getItem("userId");
    this.getAttributesTable();
    this.obtenerCorreos();
  },

  mounted() { },

  computed: {
    ...mapGetters("registroPuestos", ["Post"]),
    ...mapGetters("users", ["NombresUsers"]),


    filteredPosts() {
      if (!this.filterField) return this.Post;
      const texto = this.filterField.toLowerCase();
      return this.Post.filter(p => p.ptoNombre.toLowerCase().includes(texto));
    },

    paginatedPosts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredPosts.slice(start, start + this.itemsPerPage);
    },

    totalPages() {
      return Math.ceil(this.filteredPosts.length / this.itemsPerPage);
    },
  },

  methods: {
  
    registrarAsignacion(idProyecto) {
      console.log(this.columns[1].cards, idProyecto)

      const arreglo = []; // el arreglo donde guardamos los IDs

      this.columns[1].cards.map(r => {
        arreglo.push(r.codigo);

        console.log(arreglo)


      })
    },

    ...mapActions("registroPuestos", [
      "getAttributesTable",
      "registrarPuesto",
      "modificarPuesto",
    ]),

  

    async enviarCorreoNuevoPuesto() {
      try {
        // 🔄 Activar loading (opcional)
        // this.destinatarios = 'gvicente@gruposolimano.com.pe,cluyo@gruposolimano.com.pe'
        const payload = {
          nombrePersona: this.NombresUsers,
          nombrePuesto: this.from.PtoNombre,
          sector: this.from.PtoSector.descripcion,
          clasificacion: this.from.PtoClasificacion.descripcion,
          // categoria: this.categoria,
          destinatario: this.destinatarios  // ejemplo: "correo1@x.com,correo2@x.com"
        };

        const response = await this.axios.post(
          "PuestoData/CorreoAprobacionPuesto",
          null, // 🔥 SIN Body JSON, porque enviamos como querystring
          { params: payload }
        );
        console.log(response)

      } catch (error) {
        console.error("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Error en el servidor",
          text: error.message,
        });
      }
    },

    async obtenerCorreos() {
      const perfiles = "6"; // ejemplo

      try {
        const response = await this.axios.get(
          `PuestoData/ObtenerCorreosPorPerfil?perfil=${perfiles}`
        );

        if (response.data && response.data.success) {
          this.destinatarios = response.data.correos
        }
      } catch (error) {
        console.error("❌ Error al obtener correos:", error);
      }
    },

 
 

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      return (
        items.ptoNombre
          .toLocaleLowerCase()
          .indexOf(this.filterField.toLocaleLowerCase()) >= 0
      );
    },

 
   

 
    regresar() {
      this.$router.push("/");
    },
    filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 900);
    },


  },
};
</script>

<style scoped>
.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565c0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}

.icono-archivo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border: 2px solid #0d6efd;
  /* color azul Bootstrap */
  border-radius: 50%;
  /* forma circular */
  transition: 0.3s;
}

.icono-archivo:hover {
  background-color: #0d6efd;
}

.icono-archivo:hover i {
  color: white !important;
}

.icono-archivo i {
  font-size: 1.4rem;
}

#file-upload {
  display: none;
}

.board {
  display: flex;
}

.column {
  flex-shrink: 0;
}

.card {
  border-radius: 5px;
}
</style>
